import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import { ANNOUNCEMENT_SERVICE, EMPLOYEE_SERVICE, IMAGE_SERVICE } from '../EndPoints';


export const GetListAnnouncements = createAsyncThunk(
    'announcements/getListAnnouncements',
    async (body, { dispatch, getState }) => {
        const result = await apiInstance
            .post(`${ANNOUNCEMENT_SERVICE.getListAnnouncements}${body.date}`, body?.pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const AnnouncementTypes = createAsyncThunk('announcements/announcementTypes', async () => {
    const response = await apiInstance
        .get(ANNOUNCEMENT_SERVICE.announcementTypes)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateAnnouncement = createAsyncThunk(
    'announcements/createAnnouncement',
    async (body, { dispatch, getState }) => {
        const result = await apiInstance
            .post(ANNOUNCEMENT_SERVICE.createAnnouncement, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const SendToAllScope = createAsyncThunk(
    'announcements/sendToAllScope',
    async (announcementId, { dispatch, getState }) => {
        const result = await apiInstance
            .get(`${ANNOUNCEMENT_SERVICE.sendToAllScope}${announcementId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const SendByTopicScope = createAsyncThunk(
    'announcements/sendByTopicScope',
    async (body, { dispatch, getState }) => {
        const result = await apiInstance
            .post(ANNOUNCEMENT_SERVICE.sendByTopicScope, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const SendToSomeEmployees = createAsyncThunk(
    'announcements/sendToSomeEmployees',
    async (body, { dispatch, getState }) => {
        const result = await apiInstance
            .post(ANNOUNCEMENT_SERVICE.sendToSomeEmployees, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetEmployeesPageable = createAsyncThunk(
    'announcements/getEmployeesPageable',
    async (body, { dispatch, getState }) => {
        const result = await apiInstance
            .post(EMPLOYEE_SERVICE.getEmployeesPageable, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);